var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulkDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.227,
    viewBox: "0 0 24 23.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12095",
    "data-name": "Group 12095",
    transform: "translate(-659.905 -857.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12080",
    "data-name": "Group 12080",
    transform: "translate(659.905 857.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171284590",
    "data-name": "Group 1171284590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12065",
    "data-name": "Group 12065",
    transform: "translate(8.059 7.284)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 7.97,
    cy: 7.97,
    rx: 7.97,
    ry: 7.97,
    fill: "#3a96df"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49598",
    "data-name": "Path 49598",
    d: "M14.624,4.91,10.573.79A2.77,2.77,0,0,0,8.6.005H2.767A2.67,2.67,0,0,0,0,2.654V16.388a2.752,2.752,0,0,0,2.767,2.747h9.881a2.752,2.752,0,0,0,2.767-2.747V6.774A2.671,2.671,0,0,0,14.624,4.91ZM3.68,7.755H6.644a.777.777,0,0,1,.791.785.725.725,0,0,1-.791.785H3.68a.785.785,0,1,1,0-1.57Zm5.929,5.494H3.68a.777.777,0,0,1-.79-.785.725.725,0,0,1,.79-.785H9.609a.785.785,0,1,1,0,1.57Z",
    transform: "translate(0 0)",
    fill: "#ff8d00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12068",
    "data-name": "Group 12068",
    transform: "translate(8.059 7.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12066",
    "data-name": "Group 12066"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 7.97,
    cy: 7.97,
    rx: 7.97,
    ry: 7.97,
    fill: "#f5e0c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12067",
    "data-name": "Group 12067",
    transform: "translate(4.698 4.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49599",
    "data-name": "Path 49599",
    d: "M30.619,25.227l-3.179-3.18a.159.159,0,0,0-.225,0l-3.169,3.18a.159.159,0,0,0,.112.271h1.748V29.47a.159.159,0,0,0,.159.159h2.542a.159.159,0,0,0,.159-.159V25.5h1.741a.159.159,0,0,0,.112-.271Z",
    transform: "translate(-24 -22)",
    fill: "#ff8d00"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkDocument);
export default __webpack_public_path__ + "static/media/bulkDocument.fdd3372e13b4baeab72164662299f599.svg";
export { ForwardRef as ReactComponent };